import { Base } from '@studiometa/js-toolkit';
/* eslint-disable */

/**
 * IframeVideo component for handling video player initialization
 */
export default class IframeVideo extends Base {
  static config = {
    name: 'IframeVideo',
  };

  /**
   * Initialize the video player when component is mounted
   */
  mounted() {
    const player = new Plyr(this.$el, {
      preload: 'metadata',
      iconUrl: '',
      controls: [],
      clickToPlay: false,
    });

    const isPlaying =
      player.currentTime > 0 &&
      !player.paused &&
      !player.ended &&
      player.readyState > player.HAVE_CURRENT_DATA;

    player.on('ready', () => {
      player.muted = true;
      player.volume = 0;

      if (!isPlaying) {
        player.play();
        player.muted = false;
        player.volume = 0.2;
      }

      this.$el.classList.add('loaded');
      this.$el.querySelector('.player-loader')?.remove();
    });
  }
}
/* eslint-enable */
